import QuoterMotors from './quoter-motors';

export default QuoterMotors;
